// extracted by mini-css-extract-plugin
export default {"container":"fF07RoTLBThv2ETRmt5h"};